const menuMegaLists = document.querySelectorAll('.menu-mega .menu__list');

const MENU_CARDS_PER_ROW = 4;

menuMegaLists.forEach((list) => {
  const inner = list.closest('.menu__inner');
  const pane = inner?.querySelector('.menu__cards-pane');
  const items = list.querySelectorAll('[data-menu-mega-nav]');
  const cardLists = pane ? pane.querySelectorAll('[data-menu-mega-cards]') : [];

  const updateRows = () => {
    if (!inner) {
      return;
    }

    let cardCount = 0;
    const level1List = pane?.querySelector('.menu__card-list--level-1');

    if (level1List) {
      cardCount += level1List.querySelectorAll('.menu__card').length;
    }

    const activeList = pane?.querySelector('[data-menu-mega-cards].is-active');

    if (activeList) {
      cardCount += activeList.querySelectorAll('.menu__card').length;
    }

    const rows = Math.max(1, Math.ceil(cardCount / MENU_CARDS_PER_ROW));

    inner.style.setProperty('--menu-rows', rows);
  };

  const activate = (index) => {
    items.forEach((item, itemIndex) => {
      item.classList.toggle('is-active', itemIndex === index);
    });

    cardLists.forEach((cardList, cardListIndex) => {
      cardList.classList.toggle('is-active', cardListIndex === index);
    });

    updateRows();
  };

  const firstIndexWithCards = Array.from(cardLists).findIndex((cardList) =>
    cardList.querySelector('.menu__card')
  );
  const defaultIndex = firstIndexWithCards >= 0 ? firstIndexWithCards : 0;

  if (items.length > 0) {
    activate(defaultIndex);
  } else {
    updateRows();
  }

  items.forEach((item, index) => {
    const heading = item.querySelector('h5');

    if (!heading) {
      return;
    }

    heading.addEventListener('mouseenter', () => activate(index));
    heading.addEventListener('focusin', () => activate(index));
  });
});
